(function () {
  const pendingKey = 'cabotQuoteSubmissionPending';
  const successPath = '/pages/quote-request-received';
  let successRecorded = false;

  function pushEvent(eventName, details) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, details || {}));
  }

  function formSource(form) {
    const sourceField = form.querySelector('input[name="contact[Lead source]"]');
    return sourceField && sourceField.value ? sourceField.value : 'Website quote form';
  }

  function recordQuoteSuccess() {
    if (successRecorded || sessionStorage.getItem(pendingKey) !== '1') return;

    const hasSuccessMessage = document.querySelector('.cabot-quote-form__status--success');
    const isThankYouPage = window.location.pathname === successPath;
    if (!hasSuccessMessage && !isThankYouPage) return;

    successRecorded = true;
    sessionStorage.removeItem(pendingKey);
    pushEvent('cabot_quote_form_success');

    if (typeof window.gtag === 'function') {
      window.gtag('event', 'generate_lead');
      window.gtag('event', 'conversion', {
        send_to: 'AW-17779537752/4Vt6COiq6t8bENju-J1C'
      });
    }
  }

  document.addEventListener('focusin', function (event) {
    const form = event.target.closest('form.cabot-quote-form');
    if (!form || form.dataset.analyticsStarted === 'true') return;

    form.dataset.analyticsStarted = 'true';
    pushEvent('cabot_quote_form_start', { form_source: formSource(form) });
  });

  document.addEventListener('submit', function (event) {
    const form = event.target.closest('form.cabot-quote-form');
    if (!form) return;

    sessionStorage.setItem(pendingKey, '1');
    pushEvent('cabot_quote_form_submit', { form_source: formSource(form) });
  });

  document.addEventListener('click', function (event) {
    const link = event.target.closest('a[href^="tel:"], a[href^="mailto:"]');
    if (!link) return;

    const isPhone = link.getAttribute('href').indexOf('tel:') === 0;
    pushEvent(isPhone ? 'cabot_phone_click' : 'cabot_email_click', {
      link_location: window.location.pathname
    });
  });

  recordQuoteSuccess();

  const observer = new MutationObserver(recordQuoteSuccess);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
